export function CardSlider() {
  this.init = function init(params) {
    this.container = params.container;
    this.navigation = this.container.querySelector('.dkt-card-slider-navigation');
    this.current = params.index || 0;
    this.numberOfItems = this.container.querySelectorAll('.dkt-card-slider-item').length;
    const item = this.container.querySelector('.dkt-card-slider-item');
    this.widthOfItems = item ? item.clientWidth : 0;
    this.numberOfVisiblesItems = this.getNumberOfVisiblesItems();
    this.actions = this.container.querySelector('.dkt-card-slider-actions');
    this.navigationInit();
    this.bindEvents();
    this.touchEvents();
    this.parent = params.parent;

    if (this.numberOfItems <= this.numberOfVisiblesItems && this.actions !== null)
      this.actions.classList.add('dkt-card-slider-actions--hidden');

    this.container.classNameToggle('dkt-card-slider-container--noactions', (this.actions === null));

    if (params.displayNewCard === true) {
      this.showNewCardForm();
    } else {
      this.changeCurrent();
    }
    this.isReady = true;
  };
}

CardSlider.prototype.getNumberOfVisiblesItems = function getNumberOfVisiblesItems() {
  return Math.floor(this.container.clientWidth / this.widthOfItems);
};

CardSlider.prototype.navigationInit = function navigationInit() {
  this.navigation = this.container.querySelector('.dkt-card-slider-navigation');
  let pagerItems = '';

  for (let i = 0; i < this.numberOfItems; i += 1) {
    pagerItems += `<li class="dkt-slider-pager-item"><button data-index="${i}">${i}</button></li>`;
  }

  this.navigation.innerHTML = `<button class="dkt-slider-button dkt-slider-button--previous">Previous</button>
    <ul class="dkt-slider-pager">
    ${pagerItems}
    </ul>
    <button class="dkt-slider-button dkt-slider-button--next">Next</button>`;
  this.navigationRefresh();
};

CardSlider.prototype.navigationRefresh = function navigationRefresh() {
  const nextButton = this.container.querySelector('.dkt-slider-button--next');
  const previousButton = this.container.querySelector('.dkt-slider-button--previous');
  const pagerItems = this.container.querySelectorAll('.dkt-slider-pager-item');

  previousButton.disabled = this.current === 0;
  nextButton.disabled = this.current >= this.numberOfItems - 1;

  const nbCard = this.container.querySelectorAll('.dkt-card-slider-item').length;

  if (nbCard < pagerItems.length) {
    pagerItems[0].remove();
  }

  // Update items
  let allDisabled = true;
  for (let i = 0; i < pagerItems.length; i += 1) {
    if (i >= this.current && i < this.current + this.numberOfVisiblesItems) {
      pagerItems[i].classList.add('dkt-slider-pager-item--current');
      pagerItems[i].querySelector('button').disabled = true;
    } else {
      pagerItems[i].classList.remove('dkt-slider-pager-item--current');
      pagerItems[i].querySelector('button').disabled = false;
      allDisabled = false;
    }
  }

  this.container.classNameToggle('dkt-card-slider-container--noactions', allDisabled);
  this.navigation.classNameToggle('dkt-card-slider-navigation--hidden', allDisabled);
};

CardSlider.prototype.bindEvents = function bindEvents() {
  const $this = this;
  const nextButton = this.container.querySelector('.dkt-slider-button--next');
  const previousButton = this.container.querySelector('.dkt-slider-button--previous');
  const pagerItems = this.container.querySelectorAll('.dkt-slider-pager-item button');
  const createButton = this.container.querySelectorAll('.dkt-create-card');
  const closeButton = this.container.querySelector('.dkt-button-close');

  nextButton.addEventListener('click', this.nextSlide.bind(this));
  previousButton.addEventListener('click', this.previousSlide.bind(this));

  [...pagerItems].forEach(item => {
    item.addEventListener('click', () => this.goToItem(item));
  });

  if (createButton !== null) {
    [...createButton].forEach(button => {
      button.addEventListener('click', $this.showNewCardForm.bind($this));
    });
  }

  if (closeButton !== null) {
    closeButton.addEventListener('click', event => this.closeForm(event));
  }
};

CardSlider.prototype.closeForm = function closeForm(event) {
  event.preventDefault();
  this.container.classList.remove('dkt-card-slider-container--new');
  if (this.parent && this.parent.selectFavoriteToken === undefined) {
    if (this.parent && this.parent.onNewCardFormDisplayChanged) {
      this.parent.onNewCardFormDisplayChanged(false);
    }
    this.current = this.numberOfItems - this.numberOfVisiblesItems;
    this.changeCurrent();
  } else {
    this.parent.selectFavoriteToken.bind(this);
    if (this.parent && this.parent.onNewCardFormDisplayChanged) {
      this.parent.onNewCardFormDisplayChanged(false);
    }
  }
};

CardSlider.prototype.goToItem = function goToItem(item) {
  const { numberOfItems, numberOfVisiblesItems, parent } = this;
  this.current = typeof item === 'number' ? item : Number(item.dataset.index);
  if (this.current > numberOfItems - numberOfVisiblesItems) {
    this.current = numberOfItems - numberOfVisiblesItems;
  }

  if (this.current === numberOfItems - numberOfVisiblesItems - 1 && parent.selectFavoriteToken) {
    parent.selectFavoriteToken();
  } else {
    this.changeCurrent();
  }
};

CardSlider.prototype.previousSlide = function previousSlide() {
  this.current -= 1;
  this.changeCurrent();
};

CardSlider.prototype.nextSlide = function nextSlide() {
  this.current += 1;
  this.changeCurrent();
};

CardSlider.prototype.displayCard = function displayCard(card) {
  const isAddingCard = this.numberOfVisiblesItems === 1 || card.isNewAccount;
  if (isAddingCard || card.index > this.numberOfItems - this.numberOfVisiblesItems) {
    if (isAddingCard) {
      this.current = card.index;
    } else {
      this.current = this.numberOfItems - this.numberOfVisiblesItems;
    }
    this.changeCurrent();
  } else if (card.index === 0) {
    this.current = card.index;
    this.changeCurrent();
  }
};

CardSlider.prototype.changeCurrent = function changeCurrent() {
  if (this.actions !== null && this.actions) {
    const condition = (this.current >= this.numberOfItems - this.numberOfVisiblesItems);
    this.actions.classList.toggle('dkt-card-slider-actions--hidden', condition);
  }

  this.moveSlider();
};

CardSlider.prototype.showNewCardForm = function showNewCardForm() {
  if (this.parent && this.parent.onNewCardFormDisplayChanged) {
    this.parent.onNewCardFormDisplayChanged(true);
  }

  if (this.numberOfVisiblesItems >= 2) {
    this.current = this.numberOfItems - this.numberOfVisiblesItems + 1;
  } else {
    this.current = this.numberOfItems - this.numberOfVisiblesItems;
  }

  this.changeCurrent();
  if (this.container.querySelector('.dkt-card--verso fieldset') !== null) {
    this.container.querySelector('.dkt-card--verso fieldset').disabled = false;
  }
  this.container.classList.add('dkt-card-slider-container--new');
  if (this.numberOfItems > 1) {
    this.navigation.classList.remove('dkt-card-slider-navigation--hidden');
  }
};

CardSlider.prototype.moveSlider = function moveSlider() {
  const $this = this;
  const slides = this.container.querySelectorAll('.dkt-card-slider-item');

  [...slides].map(slide => {
    const newSlide = slide;
    newSlide.style.transform = `translateX(-${$this.current * 100}%)`;
    return newSlide;
  });

  this.navigationRefresh();
  if (this.haveToFlip !== false) {
    this.container.classList.remove('dkt-card-slider-container--new');
  }
};

CardSlider.prototype.deleteItem = function deleteItem(index) {
  const $this = this;
  const slides = this.container.querySelectorAll('.dkt-card-slider-item');
  slides[index].style.width = 0;
  slides[index].style.height = 0;
  slides[index].style.padding = 0;

  slides[index].addEventListener('transitionend', () => {
    slides[index].remove();
    $this.numberOfItems -= 1;
    $this.navigationRefresh();

    if ($this.parent.onTokenDelete) {
      $this.parent.onTokenDelete(index);
    }
  });
};

CardSlider.prototype.addItem = function addItem(item) {
  const lastCard = this.container.querySelector('.dkt-flipable');
  lastCard.parentNode.insertBefore(item, lastCard);
  this.numberOfItems += 1;
  item.addEventListener('transitionend', e => {
    if (e.target === item && e.propertyName === 'width') {
      item.classList.remove('dkt-card-slider-item--hideCard');
    }
  });
  setTimeout(() => {
    item.classList.remove('dkt-card-slider-item--new');
  }, 100);
  this.navigationInit();
  this.bindEvents();
  this.moveSlider();
};

CardSlider.prototype.touchEvents = function touchEvents() {
  const $this = this;
  let startx = 0;
  let dist = 0;

  function getTouchObject(e) {
    let touchobj;

    if (e.changedTouches) {
      touchobj = e.changedTouches[0];
    } else {
      touchobj = e.originalEvent.changedTouches[0];
    }

    return touchobj;
  }

  this.container.addEventListener('touchstart', e => {
    dist = 0;
    startx = parseInt(getTouchObject(e).clientX, 10);
  });

  this.container.addEventListener('touchmove', e => {
    const slides = $this.container.querySelectorAll('.dkt-card-slider-item');

    dist = parseInt(getTouchObject(e).clientX, 10) - startx;
    if (Math.abs(dist) > 20) {
      e.preventDefault();
    }

    const distanceToMove = ($this.current * $this.widthOfItems * -1) + dist;

    [...slides].map(slide => {
      const newSlide = slide;
      newSlide.style.transition = 'none';
      newSlide.style.transform = `translateX(${distanceToMove}px)`;
      return newSlide;
    });
  });

  this.container.addEventListener('touchend', () => {
    let direction;
    let numberOfSlidesToMove;
    let shift;
    let nextItemIndex;

    if (Math.abs(dist) > 15) {
      const slides = this.container.querySelectorAll('.dkt-card-slider-item');

      [...slides].map(slide => {
        const newSlide = slide;
        newSlide.style.transition = 'all ease-in-out 0.5s';
        return newSlide;
      });

      if (dist < 0) {
        direction = 'next';
      } else {
        direction = 'previous';
      }

      numberOfSlidesToMove = Math.floor(Math.abs(dist / this.widthOfItems));
      shift = Math.abs((dist / this.widthOfItems) - numberOfSlidesToMove);

      if (shift > 0.3) {
        numberOfSlidesToMove += 1;
      }

      if (direction === 'next') {
        nextItemIndex = this.current + numberOfSlidesToMove;
      } else {
        nextItemIndex = this.current - numberOfSlidesToMove;

        if (this.parent.selectFavoriteToken) {
          this.parent.selectFavoriteToken();
        }
      }

      if (nextItemIndex <= 0) {
        this.current = 0;
      } else if (nextItemIndex > this.numberOfItems - this.numberOfVisiblesItems) {
        this.current = this.numberOfItems - this.numberOfVisiblesItems;
      } else {
        this.current = nextItemIndex;
      }

      this.haveToFlip = this.current !== this.numberOfItems - 1;

      this.changeCurrent();
    }
  });
};


CardSlider.prototype.displayFocusedCard = function displayFocusedCard (focusedElement) {
  this.goToItem(focusedElement.closest('.dkt-card-slider-item'));
};



// WEBPACK FOOTER //
// ./src/checkout/payment/card-slider.js